import React from 'react';
import propTypes from 'prop-types';

export const BusIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      stroke={color}
      strokeWidth={14}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 472.666 472.666"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      enableBackground="new 0 0 472.666 472.666"
    >
      <g>
        <path d="m385.996,48.833c0-4.142-3.357-7.5-7.5-7.5h-284.326c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5 7.5,7.5h284.326c4.143,0 7.5-3.358 7.5-7.5z" />
        <path d="m284.964,312.708h-97.262c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5 7.5,7.5h97.262c4.143,0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5z" />
        <path d="M452.166,81.333h-26.17v-27.5c0-28.949-23.552-52.5-52.5-52.5H99.17c-28.948,0-52.5,23.551-52.5,52.5v27.5H20.5   c-11.304,0-20.5,9.196-20.5,20.5v60.881c0,11.304,9.196,20.5,20.5,20.5h3.67c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5H20.5   c-3.032,0-5.5-2.467-5.5-5.5v-60.881c0-3.033,2.468-5.5,5.5-5.5h26.17v305.25c0,6.963,4.098,12.972,10,15.787v46.463   c0,4.142,3.357,7.5,7.5,7.5h64.145c4.143,0,7.5-3.358,7.5-7.5v-22.25c0-4.142-3.357-7.5-7.5-7.5s-7.5,3.358-7.5,7.5v14.75H71.67   v-37.25h329.326v37.25h-49.144v-14.75c0-4.142-3.357-7.5-7.5-7.5s-7.5,3.358-7.5,7.5v22.25c0,4.142,3.357,7.5,7.5,7.5h64.144   c4.143,0,7.5-3.358,7.5-7.5V417.37c5.902-2.816,10-8.824,10-15.787V96.333h26.17c3.032,0,5.5,2.467,5.5,5.5v60.881   c0,3.033-2.468,5.5-5.5,5.5h-3.67c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5h3.67c11.304,0,20.5-9.196,20.5-20.5v-60.881   C472.666,90.529,463.47,81.333,452.166,81.333z M61.67,53.833c0-20.678,16.822-37.5,37.5-37.5h274.326   c20.678,0,37.5,16.822,37.5,37.5v27.5H61.67V53.833z M410.996,362.708h-71.033c-9.649,0-17.5-7.851-17.5-17.5v-17.5h66.033   c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5h-73.533c-4.143,0-7.5,3.358-7.5,7.5v25c0,17.92,14.579,32.5,32.5,32.5h71.033   v23.875c0,1.355-1.145,2.5-2.5,2.5H64.17c-1.355,0-2.5-1.145-2.5-2.5v-23.875h71.033c17.921,0,32.5-14.58,32.5-32.5v-25   c0-4.142-3.357-7.5-7.5-7.5H84.17c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5h66.033v17.5c0,9.649-7.851,17.5-17.5,17.5H61.67   V96.333h167.163v185H84.17c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5h304.326c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5   H243.833v-185h167.163V362.708z" />
      </g>
    </svg>
  );
};
BusIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
BusIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
